/**
 * The different types of sorting we support for search results.
 */
export const SEARCH_SORT_TYPES = {
  Recommended: 'Recommended',
  PriceASC: 'PriceASC',
  PriceDESC: 'PriceDESC',
  DistanceASC: 'DistanceASC',
} as const
Object.freeze(SEARCH_SORT_TYPES)
export type SEARCH_SORT_TYPES = (typeof SEARCH_SORT_TYPES)[keyof typeof SEARCH_SORT_TYPES]

export const BUDGET_FRIENDLY_MIN_PRICE = 0
export const BUDGET_FRIENDLY_MAX_PRICE = 200

export const US_THANKSGIVING_DATES = {
  start: '2026-11-26',
  end: '2026-11-29',
} as const
Object.freeze(US_THANKSGIVING_DATES)
export type US_THANKSGIVING_DATES = typeof US_THANKSGIVING_DATES

export const CANADA_THANKSGIVING_DATES = {
  start: '2026-10-09',
  end: '2026-10-12',
} as const
Object.freeze(CANADA_THANKSGIVING_DATES)
export type CANADA_THANKSGIVING_DATES = typeof CANADA_THANKSGIVING_DATES
